var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "video-collection-placeholder p-2 h-100" }, [
    _c("div", { staticClass: "video-collection-placeholder__image h-100" }),
    _vm._v(" "),
    _c("small", { staticClass: "video-collection-placeholder__indicator" }, [
      _vm._v(_vm._s(_vm.props.index + 1))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video-collection-placeholder__text my-3 w-100" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }